// P:\0PJ\synforge\frontend\lib\api\core.ts v1 2026.08.26
// axios 인스턴스 + 인터셉터(토큰 자동첨부, 401 시 refresh) — 모든 도메인 API 파일이 여기서 가져다 쓴다.
import axios from "axios"

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || "http://127.0.0.1:8000/api",
  headers: { "Content-Type": "application/json" },
})

const PUBLIC_URLS = ["/auth/login/", "/auth/register/", "/design-tokens/", "/billing/pricing/"]

api.interceptors.request.use((config) => {
  const isPublic = PUBLIC_URLS.some((url) => config.url?.includes(url))
  if (!isPublic && typeof window !== "undefined") {
    const token = localStorage.getItem("access_token")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }
  }
  return config
})

// 동시에 여러 요청이 401을 만나면 각자 refresh 를 호출해 레이스가 생겼다
//   (서버 재시작 직후 여러 API가 한꺼번에 401을 맞은 경우, 2026.09.12 실측 —
//   로그인 화면이 잠깐 떴다 사라지는 현상). 진행 중인 refresh Promise 하나를
//   공유해서, 여러 요청이 몰려도 실제 refresh 호출은 한 번만 나가게 한다.
let refreshPromise: Promise<string> | null = null

function doRefresh(): Promise<string> {
  if (refreshPromise) return refreshPromise
  const refreshToken = localStorage.getItem("refresh_token")
  if (!refreshToken) {
    return Promise.reject(new Error("no refresh token"))
  }
  refreshPromise = axios
    .post(
      `${process.env.NEXT_PUBLIC_API_URL || "http://127.0.0.1:8000/api"}/auth/token/refresh/`,
      { refresh: refreshToken }
    )
    .then((res) => {
      const newAccessToken = res.data.access
      localStorage.setItem("access_token", newAccessToken)
      return newAccessToken
    })
    .finally(() => {
      refreshPromise = null
    })
  return refreshPromise
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/auth/login/")
    ) {
      originalRequest._retry = true
      try {
        const newAccessToken = await doRefresh()
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`
        return api(originalRequest)
      } catch {
        localStorage.removeItem("access_token")
        localStorage.removeItem("refresh_token")
        if (typeof window !== "undefined" && window.location.pathname !== "/login") {
          window.location.href = "/login"
        }
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)
export default api